export default __webpack_public_path__ + "static/media/rupee-bag.ade4cf82.svg";